import styled from 'styled-components'

const MenuNavStyle = styled.div`
  .nav {
    display: flex;
    align-items: center;
    list-style-type: none;
    padding: 0;
  }

  .nav > li {
    margin: 0 40px;
  }

  .nav > li:last-child {
    border-radius: 4px;
    border: solid 1px white;
    padding: 10px 46px;
    width: 162px;
    height: 42px;
    margin-right: 0;
  }

  .nav > li > a,
  .nav > li > span {
    color: #fff;
    font-family: Ubuntu-Medium, sans-serif;
    opacity: 0.84;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.43;
    letter-spacing: 0.9px;
    cursor: pointer;
  }

  .logo-opis {
    padding-left: 16px;
  }

  @media (min-width: 768px) {
    .nav {
      display: flex;
    }
  }
  @media (max-width: 767px) {
    .nav {
      display: none;
    }
  }
`
export default MenuNavStyle
